export const LIST_FOCUSABLE_ELEMENT_TYPE = {
  FALLBACK_ELEMENT: 'FALLBACK_ELEMENT',
  LIST_ROW_ELEMENT: 'LIST_ROW_ELEMENT'
};
